import React from 'react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { NonDeliveryDaysStyles } from './non-delivery-days.styles';
import { WEEKDAYS } from './non-delivery-days.constants';

const useStyles = makeStyles(NonDeliveryDaysStyles);

const WeekdayHeaderRow: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid container alignItems="center" spacing={2} className={classes.checkboxGrid}>
      <Grid item xs={3} className={classes.title} />
      {WEEKDAYS.map(day => (
        <Grid item key={day} xs={1} className={classes.checkboxItem}>
          <Typography align="center" variant="subtitle2">
            {day}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default WeekdayHeaderRow;
